import { Link } from "react-router-dom";
import { ShieldCheck, Question } from "@phosphor-icons/react";

export default function PrivacyAlert({ onDismiss }) {
  return (
    <div
      className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
      data-testid="privacy-alert-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="privacy-alert-title"
    >
      <div className="bg-white w-full max-w-lg border border-black/10 shadow-2xl">
        <div className="flex items-center justify-between p-5 border-b border-black/10">
          <div className="flex items-center gap-2">
            <ShieldCheck size={18} weight="duotone" className="text-[#2400FF]" />
            <span id="privacy-alert-title" className="font-heading font-semibold text-base">A quick note on your data</span>
          </div>
        </div>
        <div className="p-5 space-y-3 text-sm text-neutral-700 leading-relaxed">
          <p>
            MyResumeDesign is a <b>session-only</b> tool. It does not create an account for you and does
            not store any of the personal information you enter — name, contact details, experience,
            photos or uploaded résumés — on any server or database.
          </p>
          <p>
            Everything you type or upload lives only in your current browser tab. This is a one-time
            generation experience: as soon as you close this tab or navigate away, your data is wiped and
            cannot be recovered by us or by you.
          </p>
          <p className="text-neutral-900">
            <b>Please download the PDF before closing the app.</b> That downloaded file is the only lasting
            copy of your résumé. A paid download unlocks the watermark-free PDF up to <b>3 times</b> in the same session.
          </p>
          <p className="text-xs text-neutral-500">
            For details, see our{" "}
            <Link to="/privacy" target="_blank" rel="noreferrer" className="underline hover:text-black" data-testid="privacy-alert-privacy-link">Privacy Policy</Link>
            {" "}and{" "}
            <Link to="/terms" target="_blank" rel="noreferrer" className="underline hover:text-black" data-testid="privacy-alert-terms-link">Terms &amp; Conditions</Link>.
          </p>
        </div>
        <div className="p-5 border-t border-black/10 flex items-center justify-end gap-3">
          <Link
            to="/help"
            target="_blank"
            rel="noreferrer"
            className="btn-secondary text-xs"
            data-testid="privacy-alert-help-link"
          >
            <Question size={14} weight="bold" />
            Open help
          </Link>
          <button
            onClick={onDismiss}
            className="btn-primary text-xs px-5"
            data-testid="privacy-alert-acknowledge"
            autoFocus
          >
            I understand — start building
          </button>
        </div>
      </div>
    </div>
  );
}
